import { CollectionReference, DocumentReference, collection, doc } from 'firebase/firestore'
import type { Firestore } from 'firebase/firestore'

export const useDb = () => {
  const firestore = useNuxtApp().$clientFirebaseFirestore as Firestore

  const config = useAppConfig().hiyieldNuxtLayerFirebase
  const dbCollectionsConfig = config?.dbCollections || {}

  const collections: Record<string, { ref: CollectionReference; doc: (id: string) => DocumentReference }> = {}

  for (const key in dbCollectionsConfig) {
    const ref = collection(firestore, key)
    collections[key] = { ref, doc: (id: string) => doc(ref, id) }
  }

  type AppCollCofig = typeof dbCollectionsConfig

  type AppConfigCollections = {
    [K in keyof AppCollCofig]: {
      ref: CollectionReference<AppCollCofig[K]['type']>
      doc: (id: string) => DocumentReference<AppCollCofig[K]['type']>
    }
  }

  return <AppConfigCollections>{ ...collections }
}
